import { render, staticRenderFns } from "./InputUnits.vue?vue&type=template&id=24ceacab"
import script from "./InputUnits.vue?vue&type=script&lang=js"
export * from "./InputUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports